import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

interface Props {
  selectedLocationsIds: string[] | null
  disabled: boolean
  onSelectedLocationsChanged: (ids: string[]) => void
  mandatory?: boolean
  locations: Array<{ id: string; name: string }>
}

const LocationMultiselector = ({
  selectedLocationsIds,
  disabled,
  onSelectedLocationsChanged,
  mandatory,
  locations,
}: Props) => {
  const [locationIds, setLocationIds] = useState(selectedLocationsIds)

  const handleChangeLocations = (ids: string[]) => {
    setLocationIds(ids)
    onSelectedLocationsChanged(ids)
  }

  const locationOptions = locations.map((location) => {
    return (
      <Selector.Option
        key={location.id}
        value={location.id}
        label={location.name}
        searchValue={location.name}
        isDisabled={disabled}
        isChecked={locationIds?.includes(location.id)}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {location.name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  return (
    <Selector.Popover
      inputStyle="tags"
      label={i18n.t('settings.permissions.visibility.choices.dynamic_group_options.location')}
      headerLabel={i18n.t('common.all')}
      blankLabel={i18n.t('common.empty')}
      allSelectedLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      searchPlaceholder={i18n.t('common.search')}
      icon="office"
      maxHeight="s300"
      value={locationIds ? locationIds : []}
      onChange={(ids) => handleChangeLocations(ids as string[])}
      onToggle={(isOpen) => !isOpen}
      isMultiSelect
      isDisabled={disabled}
      mandatory={mandatory}
    >
      {locationOptions}
    </Selector.Popover>
  )
}
export default observer(LocationMultiselector)
